var prefix = require('./prefix')

module.exports = prefix ? 'webkitAnimation' : 'animation'
